/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

/* eslint-disable no-console */
import $ from 'jquery';
import React, { ComponentType, RefObject } from 'react';
import { IBottomContainerComponentProps } from '../types/tableVisualizationTypes';
import TableHeaderRowComponentHOC, { ITableHeaderRowComponentProps } from './TableHeaderRowComponent';
import { TableCellComponent } from './TableCellComponent';

export function GrantTotalContainerComponentHOC(Row: ComponentType<ITableHeaderRowComponentProps>) {

    return class BottomContainerComponent extends React.Component<IBottomContainerComponentProps> {

        viewPortRef: RefObject<any>;

        constructor(props: IBottomContainerComponentProps) {
            super(props);
            this.onScroll = this.onScroll.bind(this);
            this.viewPortRef = React.createRef();
        }

        componentDidMount(): void {
            this.initializeScrollbars();
        }

        componentDidUpdate(): void {
            this.initializeScrollbars();
        }

        componentWillUnmount() {
            this.removeScrollbars();
        }

        onScroll(event: any) {
            this.props.onScrollCallback(event);
        }

        initializeScrollbars() {
            if (!this.props.useScroll) {
                return;
            }
            if (!this.viewPortRef.current) {
                return;
            }
            // @ts-ignore
            $(this.viewPortRef.current).perfectScrollbar();
            this.viewPortRef.current.addEventListener('scroll', this.onScroll);
        }

        removeScrollbars() {
            if (!this.viewPortRef.current) {
                return;
            }
            this.viewPortRef.current.removeEventListener('scroll', this.onScroll);
            // @ts-ignore
            $(this.viewPortRef.current).perfectScrollbar('destroy');
        }

        render() {

            const {
                getRef, bottomOffset, bottom, linkOptions, linkToRefObjectPairs
            } = this.props;
            const { cells } = bottom;

            getRef(this.viewPortRef);

            const bottomContainerStyles = {
                overflow: 'hidden',
                bottom: `${bottomOffset}px`,
                width: '100%'
            };

            return (
                <div
                    ref={this.viewPortRef}
                    className="jr jr-mDatatable-bottomContainer jr-jTableBottomContainer"
                    style={bottomContainerStyles}
                >
                    <table
                        className="jr-mDatatable jr"
                        unselectable="on"
                        js-stdnav="true"
                        js-navtype="table"
                        aria-label="Table. Use Alt and direction arrow keys for pagination"
                    >
                        <tfoot className="jr-mDatatable-header jr">
                            <Row
                                row={{ cells }}
                                linkToElemPairs={linkToRefObjectPairs}
                                linkOptions={linkOptions}
                            />
                        </tfoot>
                    </table>
                </div>
            );
        }
    }
}

const Row = TableHeaderRowComponentHOC(TableCellComponent);
export const GrantTotalContainerComponent = GrantTotalContainerComponentHOC(Row);
